import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content-container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "content-container"
}
const _hoisted_5 = { class: "top-content" }
const _hoisted_6 = { class: "flex-row-centered" }
const _hoisted_7 = { class: "center-buttons" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "table-container" }

import { ref, onMounted, computed, provide } from "vue";
import { marketSelection } from "@/services/helpers/Helper";
import TableLite from "@/components/TableLite.vue";
import ChurnPaymentItem from "@/Interfaces/Payments/ChurnPaymentItem";
import ChurnPaymentPopUp from "@/components/ChurnPaymentPopUp.vue";
import DatePeriod from "@/types/DatePeriod";
import { churnPayments } from "@/services/network";
import PeriodSelector from "@/components/PeriodSelector.vue";
import MarketSelector from "@/components/MarketSelector.vue";
import useNotifier from "@/services/composables/Notifier";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";

interface RowWrapper<T> {
    checked: boolean;
    value: T;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ChurnPayments',
  setup(__props) {

const cols: (keyof ChurnPaymentItem)[] = [
    "journalInvoiceReference",
    "periodMonth",
    "balance",
    "dueDate"
];
const labels = [
    "Journal Invoice Reference",
    "Period Month",
    "Balance",
    "Due Date"
]
const page = ref(1);
provide("page", page);
const period = ref(new DatePeriod());

// Table
const isLoading = ref(false);
const allPayments = ref<ChurnPaymentItem[]>([]);
const displayedPayments = computed(() =>
    period.value.isValid() ?
        allPayments.value?.filter(x => x.periodMonth.valueOf() === period.value.valueOf()) :
        allPayments.value
);
const checkedRow = ref<ChurnPaymentItem>();
const hasCheckboxes = ref(false);
const selectedRow = ref<ChurnPaymentItem>();

onMounted(async () => {
    marketSelection.value = "GB";
    getPayments();
});
async function getPayments() {
    try{
        isLoading.value = true;
        const p = (await churnPayments.get()).data;
        allPayments.value = (p === '' ? [] : p).map(x=>new ChurnPaymentItem(x));

        if (period.value.isValid()) {
            updateSelection();
        }
    }catch(error) {
        useNotifierWithErrFormatter().error({error, errorType: "Getting Churn Payments"})
    }finally{
        isLoading.value = false;
    }
}
function updateSelection() {
    checkedRow.value = undefined;
    selectedRow.value = checkedRow.value!;

    hasCheckboxes.value = period.value.isValid();
}
function proceedToPayment() {
    selectedRow.value = checkedRow.value;
    if (!selectedRow.value) useNotifier().notify({msg:'No item selected'});
}
function UpdateCheckedRows(row: RowWrapper<any>, rows: RowWrapper<any>[]) {
    if (row.value == checkedRow.value) {
        row.checked = false;
        checkedRow.value = undefined;
    } else {
        rows.forEach(x=>x.checked = false);
        row.checked = true;
        checkedRow.value = row.value;
    }
}
function refreshAfterConfirm() {
    getPayments();
    checkedRow.value = undefined;
}

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(MarketSelector),
            _createVNode(PeriodSelector, {
              modelValue: period.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((period).value = $event)),
                updateSelection
              ],
              hasNullSelector: "",
              id: "periodSelector",
              showTitle: "",
              filter: (p)=>allPayments.value?.some(x=>p.within(x.periodMonth))
            }, null, 8, ["modelValue", "filter"]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                disabled: !hasCheckboxes.value,
                onClick: proceedToPayment,
                class: "incident-nav-button"
              }, " Confirm Payment ", 8, _hoisted_8)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(TableLite, {
            Rows: displayedPayments.value,
            Cols: cols,
            Labels: labels,
            RowsPerPage: 50,
            HideTable: false,
            HasCheckBox: hasCheckboxes.value,
            UpdateCheckedRows: UpdateCheckedRows,
            checkAll: false,
            checkedRow: checkedRow.value
          }, null, 8, ["Rows", "HasCheckBox", "checkedRow"])
        ]),
        _createVNode(ChurnPaymentPopUp, {
          modelValue: selectedRow.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedRow).value = $event)),
          onConfirm: refreshAfterConfirm
        }, null, 8, ["modelValue"])
      ]))
}
}

})